declare const Phaser: any;

import { BaseScene } from "../../framework/BaseScene";

export class EventScene extends BaseScene {
  constructor() {
    super({ key: "EventScene" });
  }

  onReady(_data?: any): void {
    this.add.rectangle(400, 225, 800, 450, 0x1a1a2e);

    this.add.text(400, 60, "EVENT", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "32px",
      color: "#6366f1",
      fontStyle: "bold",
    }).setOrigin(0.5);

    this.add.text(400, 180, "?", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "72px",
      color: "#818cf8",
      fontStyle: "bold",
    }).setOrigin(0.5);

    this.add.text(400, 260, "Something mysterious happened...", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      color: "#9ca3af",
    }).setOrigin(0.5);

    // Continue button
    const btn = this.add.rectangle(400, 340, 140, 40, 0x374151);
    btn.setStrokeStyle(2, 0x6366f1);
    btn.setInteractive({ useHandCursor: true });
    this.add.text(400, 340, "CONTINUE", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      color: "#e5e7eb",
      fontStyle: "bold",
    }).setOrigin(0.5);

    btn.on("pointerdown", () => {
      this.sm.pop({ outcome: "continued" });
    });
  }

  onUpdate(_time: number, _delta: number): void {}
}
